/**=========================================================
 * Module: app-table.js
 * Handles table
 =========================================================*/

App.directive('appTable', function(){
  'use strict';

  return {
      templateUrl: '/app/views/partials/table.html' + (CONFIG && CONFIG.appVersion ? '?v=' + CONFIG.appVersion : ''),
      controller: 'TableController',
      restrict: 'E',
      replace: true,
      transclude: true,
      scope: { 
          preload: '=preload',
          table: '=table',
          data: '=data',
          range: '=range',
          qr: '=qr'
        }
  };

});
